export const refuseVariantsArray = [
  "Отказ по финансовому положению Клиента (наличие убытков, отриц. чистые активы, несоизмеримость объема компании к сумме контракта и т.д...)",
  "Отсутствие сопоставимого опыта исполнения (по объему или видам работ)",
  "Отрицательная кредитная история",
  "Не набран минимально проходной балл в рамках Модели оценки рисков",
  "Не готовы предоставить гарантию на переобеспечение",
  "Отказ по предмету контракта",
  "Клиент находится или ранее находился в РНП",
  "Наличие неоплаченных исполнительных производств",
  "Наличие незавершенных арбитражных дел",
  "Отказ в предоставлении Тендерной гарантии, по причине отказа в последующем предоставлении Гарантии на исполнение контракта.",
  "Имеется ненадлежащий опыт исполнения контрактов (не оплаченные штрафы, пени, выставленные требования, нарушения сроков, одностороннее расторжение контрактов и т.д...)",
  "Имеется иная негативная информация по Клиенту (налоговая задолженность, намерения о банкротстве, негативная информация по связанным компаниям и т.д...)",
  "Аналогичная заявка в работе у другого агента",
  "Превышен лимит на Клиента",
];
